import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TimeZoneDetails } from 'globals/store/programs.data';
import { DAY_MS } from '../../helpers/constants';
import { TimeSelectorComponent } from './time-selector.component';
import { DialogWrapperComponent } from 'src/app/components/wrappers/dialog-wrapper.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'manage-times',
    template: `
<dialog-wrapper
  [backgroundColor]="'var(--primary)'"
  [disabled]="!data.startTime || (data.endTime && data.endTime <= data.startTime)"
  [successLabel]=""
  [dialogTitle]="data.dialogTitle"
  [smallTitle]="true"
  [cancelLeft]="true"
  [showClose]="false"
  [maxHeight]="'unset'"
  [deleteLeft]="false"
  [data]="null"
  [successLabel]="data.saveLabel"
  (cancel)="dialogRef.close()"
  (submit)="submit()"
>

  <div class="times">
    <time-selector
      [timezones]="data.timezones"
      [timeZone]="data.timeZone"
      [dateTitle]="data.startName + ' DATE'"
      [timeTitle]="data.startName + ' TIME'"
      [UTCTime]="data.startTime"
      (timeChange)="changeTime($event, 'startTime')"
    ></time-selector>
    
    <div class="ending-time">
      <mat-checkbox color="primary" 
        (change)="toggleEndTime()" 
        [checked]="!!data.endTime"
      ></mat-checkbox>
      <h5>Use {{ data.endName }} Time</h5>

    </div>
    <time-selector class="end-time"
      *ngIf="!!data.endTime"
      [timezones]="data.timezones"
      [timeZone]="data.timeZone"
      [dateTitle]="data.endName + ' DATE'"
      [timeTitle]="data.endName + ' TIME'"
      [hideTimeZone]="true"
      [UTCTime]="data.endTime"
      (timeChange)="changeTime($event, 'endTime')"
    ></time-selector>
  </div>
</dialog-wrapper>
  `,
    styleUrls: ['./app-notification-dialog.scss'],
    styles: [`
    .times { display: flex; flex-direction: column; }
    .ending-time, .end-time { margin-top: 20px; }
    .ending-time { display: flex; align-items: center; margin-left: -5px; }
    mat-checkgbox { }
    ::ng-deep manage-times .mat-dialog-content.wrapper-content { height: fit-content !important; }
  `],
    standalone: true,
    imports: [TimeSelectorComponent, MatCheckboxModule, CommonModule, DialogWrapperComponent],
})

export class ManageTimesComponent {

  @ViewChild('timeInput') timeInput: ElementRef<HTMLInputElement>

  constructor(
    public dialogRef: MatDialogRef<ManageTimesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ManageTimesDialogData
  ) { 
  }
  changeTime(d: { UTCTime: number, timeZone: string }, timeKey: 'startTime' | 'endTime') {
    this.data[timeKey] = d.UTCTime
    this.data.timeZone = d.timeZone
  }

  toggleEndTime() {
    this.data.endTime = this.data.endTime ? null : this.data.startTime + 7 * DAY_MS
  }

  submit() {
    this.dialogRef.close(this.data)
  }
}
export interface ManageTimesDialogData {
  startTime: number
  startName: string
  endTime: number
  endName: string
  active: boolean
  timeZone: string
  timezones: TimeZoneDetails[]
  dialogTitle: string
  saveLabel: string
}
